import { UI, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { CustomerDetailStackParamList } from '../../../../../../../routes/types';
import { useMovementsActions } from '../../../../../../../store/customerDetail/movement/actions';
import { movementOptionQueryState } from '../../../../../../../store/customerDetail/movement/atom';
import { MovementOptionQuery } from '../../../../../../../store/customerDetail/movement/types';
import { SelectType } from '../../SelectType';

export type Option = { label: string; value: string };
export type SelectableOptionsProps = { title: { default: string; modal: string }; items: Option[] };

interface HeaderProps {
  selectOptions: SelectableOptionsProps;
}

export const Header: React.FC<HeaderProps> = ({ selectOptions }) => {
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const isMobile = useBreakpointValue({ base: true, md: false });

  const movementOptionSelected = useRecoilValue(movementOptionQueryState);

  const { updateMovementOption } = useMovementsActions(params);

  const onChangeStatemenOptionQuery = (value: string) =>
    updateMovementOption(value as MovementOptionQuery);

  const movementOptionSelectedLabelIndex = selectOptions.items.findIndex(
    (item) => item.value === (movementOptionSelected as unknown as string)
  );

  return (
    <HStack alignItems="center" justifyContent="space-between" zIndex={5}>
      <VStack space={Spacing['inline.xxxs']}>
        <SelectType
          title={selectOptions.title.default}
          onValueChange={onChangeStatemenOptionQuery}
          options={selectOptions.items}
          selectedValue={selectOptions.items[movementOptionSelectedLabelIndex].label}
        />
      </VStack>
      {!isMobile && (
        <HStack space="inline.quarck" alignItems="end">
          <UI.Icon name="Calendar" size="xxxs" color="neutral.medium" />
          <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
            Últimos 15 dias
          </UI.Text>
        </HStack>
      )}
    </HStack>
  );
};
